import { IAppLayoutAction } from "~/appLayout/state/AppLayoutStateTypes"

export const toggleRightSidebar = (forceValue?: boolean): IAppLayoutAction => ({
    type: "TOGGLE_RIGHT_SIDEBAR",
    forceValue,
})

export const toggleHeader = (): IAppLayoutAction => ({
    type: "TOGGLE_HEADER",
})
